/**
 * rhwp-studio 자체 자동저장(복구본) 끄기.
 *
 * rhwp-studio 는 편집 중 문서 전체를 브라우저 IndexedDB 에 복구본으로 저장하고,
 * 다음에 편집기가 빈 상태로 뜰 때 「문서 복구」 창을 띄운다. 왓퀴즈는 문서 열기·저장을
 * 바깥 화면이 맡으므로 이 창은 어느 대화의 문서인지 모른 채 iframe 문서만 바꾼다.
 * 학생 정보가 든 문서가 공용 PC 브라우저에 남는 문제도 있다.
 *
 * self-hosted studio 는 같은 출처라 부모 창에서 같은 저장소를 쓸 수 있다.
 * studio 는 시작할 때 설정을 한 번만 읽으므로 iframe 을 만들기 전에 호출해야 한다.
 * 키 이름은 rhwp-studio 0.8.7 기준이며 scripts/verify-rhwp-studio.mjs 가 번들에
 * 남아 있는지 검사한다.
 */
export const RHWP_SETTINGS_STORAGE_KEY = 'rhwp-settings';
export const RHWP_AUTOSAVE_DB_NAME = 'rhwpStudioAutosave';

function readSettings(storage) {
  try {
    const raw = storage.getItem(RHWP_SETTINGS_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

export function disableRhwpStudioAutosaveSettings(storage) {
  if (!storage) return false;
  try {
    const settings = readSettings(storage);
    const autosave = settings.autosave && typeof settings.autosave === 'object'
      ? settings.autosave
      : {};
    if (autosave.recoveryEnabled === false && autosave.idleSaveEnabled === false) {
      return true;
    }
    storage.setItem(
      RHWP_SETTINGS_STORAGE_KEY,
      JSON.stringify({
        ...settings,
        autosave: { ...autosave, recoveryEnabled: false, idleSaveEnabled: false },
      }),
    );
    return true;
  } catch {
    return false;
  }
}

export function deleteRhwpStudioAutosaveDrafts(idb) {
  if (!idb || typeof idb.deleteDatabase !== 'function') return Promise.resolve(false);
  return new Promise((resolve) => {
    try {
      const request = idb.deleteDatabase(RHWP_AUTOSAVE_DB_NAME);
      request.onsuccess = () => resolve(true);
      request.onerror = () => resolve(false);
      // 다른 탭의 편집기가 DB 를 열고 있으면 그 탭이 닫힐 때 지워진다. 기다리지 않는다.
      request.onblocked = () => resolve(false);
    } catch {
      resolve(false);
    }
  });
}

function safeGlobal(name) {
  try {
    return typeof window !== 'undefined' ? window[name] : undefined;
  } catch {
    return undefined;
  }
}

export function disableRhwpStudioAutosave() {
  disableRhwpStudioAutosaveSettings(safeGlobal('localStorage'));
  return deleteRhwpStudioAutosaveDrafts(safeGlobal('indexedDB'));
}
